export const YETTEL_ACCOUNT_COOKIE = 'account-logged-in-user';
export const BFF_COOKIE_HEADER = 'X-Account-Logged-In-User';
